import api from 'service/api'

const dponetAPI = api.create('dponet')

const enableCourse = async ({ userId }) => {
  return await dponetAPI.get(`/moodle/${userId}/enable_course`)
}

const moodleLotus = { enableCourse }

export default moodleLotus
